import { CompareBy } from 'types/enums'
import { IFeatureContent, IFilter, IPolicy } from 'types/interfaces'
import { comparisonCommentHasLimitValues, isLimitIcon } from './limit-display'

type ComparisonCellContent = Partial<IFeatureContent> | null | undefined

export function normalizeComparisonCellText(content: ComparisonCellContent): string {
  if (!content?.comment) return ''
  return content.comment.replace(/\s+/g, ' ').trim()
}

export function comparisonRowHasLimitValues(
  contents: ComparisonCellContent[],
): boolean {
  return contents.some(
    (c) => isLimitIcon(c?.icon) && comparisonCommentHasLimitValues(c?.comment),
  )
}

/** When fewer than two populated cells, differences mode keeps the row visible. */
export function comparisonRowAllCellsMatch(
  contents: ComparisonCellContent[],
): boolean {
  const defined = contents.filter((c) => c != null)
  if (defined.length < 2) return false
  const first = normalizeComparisonCellText(defined[0]).toLowerCase()
  return defined.every((c) => normalizeComparisonCellText(c).toLowerCase() === first)
}

export function cellWouldShowWhatsNewHighlight(
  compareBy: CompareBy,
  content: ComparisonCellContent,
  columnPolicy: IPolicy | undefined,
): boolean {
  if (!content?.is_recently_updated) return false
  if (compareBy === CompareBy.COMPANY) return !!columnPolicy?.is_new
  return true
}

export function comparisonRowHasWhatsNew(
  compareBy: CompareBy,
  contents: ComparisonCellContent[],
  selectedPolicies: IPolicy[] | undefined,
  rowPolicy: IPolicy | undefined,
): boolean {
  return contents.some((content, i) => {
    const columnPolicy = compareBy === CompareBy.COMPANY ? selectedPolicies?.[i] : rowPolicy
    return cellWouldShowWhatsNewHighlight(compareBy, content, columnPolicy)
  })
}

export function shouldHideComparisonRow(
  filter: IFilter,
  compareBy: CompareBy,
  contents: ComparisonCellContent[],
  selectedPolicies: IPolicy[] | undefined,
  rowPolicy: IPolicy | undefined,
): boolean {
  if (filter.showDifferences && comparisonRowAllCellsMatch(contents)) return true
  if (
    filter.onlyWhatsNew &&
    !comparisonRowHasWhatsNew(compareBy, contents, selectedPolicies, rowPolicy)
  )
    return true
  if (filter.showLimitsOnly && !comparisonRowHasLimitValues(contents)) return true
  return false
}
